import { gql } from "@apollo/client";
import { MENU_FIELDS, POSTS_ARCHIVE_FIELDS } from "./post.esm.js";
const TERM_FIELDS = gql`
    ${MENU_FIELDS}
    ${POSTS_ARCHIVE_FIELDS}
    fragment TermFields on CMSTerm {
        id
        description
        head: yoast_head
        slug
        name
        taxonomy
        link
        menu {
            ...MenuFields
        }
        sidebar {
            blocks: cms_blocks
        }
        footer {
            blocks: cms_blocks
        }
        posts(
            post_type: $termPostsType
            page: $termPostsPage
            per_page: $termPostsPerPage
        ) {
            total
            pages
            posts {
                ...ArchiveFields
            }
        }
    }
`;
const TERM_QUERY = gql`
    ${MENU_FIELDS}
    ${TERM_FIELDS}
    query TermQuery(
        $site: CMSSite
        $id: ID!
        $idType: CMSIDType!
        $taxonomy: CMSTaxonomyEnum!
        $termPostsType: CMSPostTypeEnum!
        $termPostsPage: String
        $termPostsPerPage: String
        $withSettings: Boolean!
    ) {
        cmsSettings(site: $site) @include(if: $withSettings) {
            menu {
                ...MenuFields
            }
        }
        cmsTerm(site: $site, id: $id, idType: $idType, taxonomy: $taxonomy) {
            ...TermFields
        }
    }
`;
gql`
    query TermsQuery($site: CMSSite, $taxonmy: CMSTaxonomyEnum!) {
        cmsTerms(site: $site, taxonomy: $taxonmy) {
            ...TermFields
        }
    }
`;
export {
  TERM_FIELDS,
  TERM_QUERY
};
